import { type Channel, ProductType } from "@/api_client";
import { CatEntryForm } from "@/components/products/cat/entry/CatEntryForm";
import { ProductContainer } from "@/components/shared/productContainer/ProductContainer";
import type { Locales } from "@/graphql/generated";
import { useEntryContentExternal } from "@/services/cms/tanstackQuery/hooks/useEntryContentExternal";
import { useEntryForWebComponents } from "../hooks/useEntryForWebComponents";

type CatEntryProps = {
  backendHost?: string;
  appPathPrefix?: string;
  skipCart: boolean;
  channel?: Channel;
  language?: string;
};

export default function CatEntry({
  backendHost,
  appPathPrefix,
  skipCart,
  channel,
  language,
}: Readonly<CatEntryProps>) {
  const { isLoading, isSubmitting, submitEntryHandler, policyHolder, user } =
    useEntryForWebComponents({
      productType: "cat",
      backendHost,
      appPathPrefix,
      skipCart,
      channel,
      language,
    });

  const { data: content, isLoading: isLoadingContent } =
    useEntryContentExternal({
      product: ProductType.CAT,
      language: language as Locales,
      appPathPrefix,
    });

  if (isLoading || isLoadingContent) return <ProductContainer.Loader />;

  return (
    <CatEntryForm
      externalIsLoading={isSubmitting}
      externalSubmitHandler={submitEntryHandler}
      externalPolicyHolder={policyHolder}
      externalUser={user}
      externalContent={content}
    />
  );
}
